import { createApp } from "vue";
import { createPinia } from "pinia";
import { createPersistedState } from "pinia-plugin-persistedstate";
import App from "./App.vue";
import router from "./router";

import { createI18n } from "vue-i18n";
import messages from "@/translations/index";
import vClickOutside from "./services/v-click-outside";

const i18n = createI18n({
    locale: "KO",
    messages: messages,
    legacy: false,
    globalInjection: true,
});

const pinia = createPinia();
pinia.use(
    createPersistedState({
        storage: localStorage,
        auto: true,
    }),
);

declare global {
    interface Window {
        daum: any;
        CKEDITOR: any;
        gtag: any;
    }
}

const app = createApp(App);
app.directive("click-outside", vClickOutside);
app.use(pinia);
app.provide("pinia", pinia);
app.use(router);
app.use(i18n);
app.mount("#app");
